import { createFileRoute } from "@tanstack/react-router";
import { supporters } from "@/data/supporters";
import { ProfilePage, profileHead, ProfileError } from "@/pages/ProfilePage";

const supporter = supporters.find((s) => s.id === "maja")!;

export const Route = createFileRoute("/moed-maja")({
  head: () => profileHead(supporter, "da"),
  errorComponent: ({ error }) => <ProfileError locale="da" error={error} />,
  component: () => <ProfilePage supporter={supporter} locale="da" />,
});
